module.exports = __webpack_public_path__ + "media/bootstrap-icons/pencil-fill-8f9e674f.svg";